export const API_BASE_URL =
  
  
//"http://localhost:8001/api/v1/";
"https://api.andamanmakeholidays.com/api/v1/";




export const API_PATHS = {
    

  //tour package
    gettravelPackage:"travelPackage/fetch",
    getspecialpackage:"travelPackage/specialPackage/fetch",
    travelpackageprice:"travelPackage/pricing",


    //gethotels
    gethotels:"hotels/fetch",
    gethotelDetails:"hotels/hotelDetails",

    //travel category
    gettravelCategory:"travelCategory/fetch",
    getsimilarpackage:"travelPackage/similarPackage/fetch",

    //getplaces
    getplaces:'places/fetch',

    //enquiry
    postenquiry:'enquiry/submit',

    //car rental
    getcarrentalpackage:"carrentalPackage/fetch",
    carrentalprice:"carrentalPackage/pricing",

    getAirportCarPrice:"airportCarCharges/fetch",
    getHourlyCarPrice:"hourlyCarCharges/fetch",

    getplacewisehotel:"placewiseHotel/fetch",
    getpickupdropprice:"pickupdrop/fetch",
    ferrySearch:"ferry/search",

    waterSports:"waterSports/fetch",
    
    propertytype:"propertyType/fetch",
    searchsuggestion:"searchsuggestion",


    //signup

    signup:"register",
    verifyotp:"verifyOtp",
    login:"login",
    generateNewAccessToken:"generateNewAccessToken",

    booktravelpackage:"travel-package/book",
    bookwatersports:"water-sports/book",
        bookcar:"car/book",
    verifyPayment:"verifyPayment",
    getBooking:"getBooking",
    getProfile:"getProfile"
  

}